module.exports = __webpack_public_path__ + "static/9-roadblocks.45e8280c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/presentations/9-roadblocks.jpg
// module id = 200
// module chunks = 35783957827783 267625579013595